import styled from 'styled-components';
import { IonHeader } from '@ionic/react';

export const IonHeaderWrapper = styled(IonHeader)`
  .ios {
    .toggle-buton {
      height: 100%;
    }
  }

  ion-button.toggle-button::part(native) {
    overflow: visible;
  }

  ion-button {
    ion-icon + ion-badge {
      position: absolute;
      font-size: 6pt;
      right: -6px;
      top: -3px;
      border-radius: 10px;
    }
  }
`;
